import { logger } from '../logging';

export interface ResponseFavoriteGateway {
  toggle(responseId: string, nextIsFavorite: boolean): Promise<void>;
}

export const createNoopResponseFavoriteGateway = (): ResponseFavoriteGateway => ({
  async toggle(responseId, nextIsFavorite) {
    logger.info('response_favorite_intent_noop', undefined, {
      op: 'response_favorite_intent',
      component: 'ResponseFavoriteGateway',
      responseId,
      nextIsFavorite,
      persisted: false,
      note: 'TODO wire backend integration',
    });
  },
});
